//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'order'
let resource_name = 'orden'
let resource_name_plural = 'ordenes'

let state = {

}

state[resource + 's'] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit }, params) {
    try {
      let res = await Vue.request.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}`, params)
      if(res.data.success && params.callback) {
        commit('pushOrder', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error creando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error creando ${resource_name}.`})
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      let res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async updateStatus ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/updateStatus`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error actualizando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error actualizando ${resource_name}.`})
      console.error(e)
    }
  },
  async cancel ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/cancel`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error cancelando ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error cancelando ${resource_name}.`})
      console.error(e)
    }
  },
  async addDiscount ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/add_discount`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando descuento.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando descuento.`})
      console.error(e)
    }
  },
  async setDeliveryAddress ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/set_delivery_address`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando dirección de envío.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando dirección de envío.`})
      console.error(e)
    }
  },
  async setPickupLocation ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/set_pickup_location`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error agregando dirección de entrega.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando dirección de entrega.`})
      console.error(e)
    }
  },
  async getByConversation ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/get_by_conversation`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ success: false })
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo orden de conversación.`})
      console.error(e)
    }
  },
  async geyByCase ({ commit }, params) {
    try {
      let res = await Vue.request.get(`${resource}/get_by_case`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ success: false })
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo orden de caso.`})
      console.error(e)
    }
  },
  async addProduct ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/add_product`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        if (res.data.error == 'INSUFFICIENT_STOCK_ERROR') {
          params.callback({error: `No hay suficiente stock disponible.`})
        } else {
          params.callback({error: `Error agregando producto.`})
        }
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando producto.`})
      console.error(e)
    }
  },
  async removeProduct ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/remove_product`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error quitando producto.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error quitando producto.`})
      console.error(e)
    }
  },
  async addProductVariant ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/add_product_variant`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        if (res.data.error == 'INSUFFICIENT_STOCK_ERROR') {
          params.callback({error: `No hay suficiente stock disponible.`})
        } else {
          params.callback({error: `Error agregando variante de producto.`})
        }
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error agregando variante de producto.`})
      console.error(e)
    }
  },
  async removeProductVariant ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/remove_product_variant`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error quitando variante de producto.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error quitando variante de producto.`})
      console.error(e)
    }
  },
  async getPaymentUrl ({ commit }, params) {
    try {
      let res = await Vue.request.post(`${resource}/${params[resource + '_id']}/get_payment_url`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo liga de pago.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo liga de pago.`})
      console.error(e)
    }
  }
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  pushOrder (state, order) {
    state.orders.push(order)
  },
  updateOrderStatus (state, data) {
    let order = state.orders.find(o => o.order_id == data.order_id)
    order.status = data.status.name
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
